import { render, staticRenderFns } from "./ProductDebugDataList.vue?vue&type=template&id=167adaf2&scoped=true"
import script from "./ProductDebugDataList.vue?vue&type=script&lang=js"
export * from "./ProductDebugDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167adaf2",
  null
  
)

export default component.exports